import React from 'react'
import ErrorScreen from './ErrorScreen'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, componentStack: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('=== ErrorBoundary caught ===')
    console.error('Error:', error)
    console.error('Stack:', error?.stack)
    console.error('Component stack:', errorInfo?.componentStack)
    this.setState({ componentStack: errorInfo?.componentStack ?? null })
  }

  resetError = () => {
    this.setState({ hasError: false, error: null, componentStack: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen
          error={this.state.error}
          componentStack={this.state.componentStack}
          resetError={this.resetError}
        />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
